import { render, staticRenderFns } from "./AlertList.html?vue&type=template&id=399052bf&scoped=true&external"
import script from "./AlertList.js?vue&type=script&lang=js&external"
export * from "./AlertList.js?vue&type=script&lang=js&external"
import style0 from "./AlertList.scss?vue&type=style&index=0&id=399052bf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399052bf",
  null
  
)

export default component.exports